import { ModuleModel } from '../../module.model.interface';
import { ProfileModel } from '../../profile/model/profile.model';

export class LabelDescriptor implements ModuleModel {
  public discriminator = 'LabelDescriptor';

  public id: string;
  public name: string;
  public description: string;
  public clerkId: string;
  public usedForDataEntryCreation: boolean;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public clerkInfo?: any;
  public clerkDetail?: ProfileModel;
  public clerkFullName?: string;

  constructor(options?: {
    id: string;
    name: string;
    description: string;
    clerkId: string;
    usedForDataEntryCreation: boolean;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.description = options.description;
      this.clerkId = options.clerkId;
      this.usedForDataEntryCreation = options.usedForDataEntryCreation;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/label/model/label.ts